import { useState, useEffect } from 'react';
import { IconButton, CardActionArea, CircularProgress, Grid, Tooltip, Paper } from '@mui/material';
import { DeleteOutlineRounded, CloudUploadOutlined, ImageRounded, AdsClickRounded } from '@mui/icons-material';
import { HighlightOffRounded } from '@mui/icons-material';
import { ImageDialog } from '../../../../../Global/Components';
import { grey, red } from '@mui/material/colors';
import { v4 } from 'uuid';
import axios from 'axios';

export default function ImageBox({ onEdit, initial, editable, onDelete }) {
  const [id] = useState(v4());
  const [uploadingImage, setUploadingImage] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [clickable, setClickable] = useState(true);
  const [sizeDialog, setSizeDialog] = useState(false);
  const [imageSize, setImageSize] = useState('contain');
  const [image, setImage] = useState(null);

  useEffect(() => {
    setClickable(initial?.clickable ?? true);
    setImage(initial?.file ?? null);
  }, [initial]);

  // function saveImageSize(size) {
  //   setImageSize(size);
  //   onEdit({ imageSize: size });
  // }

  // function handleOpenSize() {
  //   setSizeDialog(true);
  // }

  function uploadFile(e) {
    if (!e.target.files || e.target.files.length === 0 || !e.target.files[0].type.startsWith('image/')) {
      return;
    }
    const file = e.target.files[0];
    setUploadingImage(true);
    const data = new FormData();
    data.append('file', file);
    axios
      .post(`/uploader/upload-single`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => {
        const file = {
          id: v4(),
          name: res.data.file.originalname,
          location: res.data.file.location,
          type: res.data.file.mimetype,
        };
        setImage(file);
        setUploadingImage(false);
        onEdit({ file, clickable });
      })
      .catch((err) => {
        console.error(err);
        setUploadingImage(false);
      });
  }

  return (
    <Grid container style={{ height: '100%' }}>
      <Grid
        container
        style={{
          height: '100%',
          padding: 16,
          backgroundImage: image?.location ? `url('${image.location}')` : null,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          cursor: initial?.clickable === false || editable ? 'default' : 'pointer',
        }}
        onClick={() => {
          if (editable || dialog || !initial?.file || initial?.clickable === false) return;
          setDialog(true);
        }}
      >
        <Grid container item style={{ overflow: 'hidden', position: 'relative', flex: 1 }} alignItems="center">
          {editable ? (
            <>
              <Tooltip title={clickable ? 'Make NOT clickable' : 'Make clickable'}>
                <IconButton
                  style={{
                    position: 'absolute',
                    right: 40,
                    top: 4,
                    zIndex: 5,
                  }}
                  onClick={() => {
                    const value = !clickable;
                    onEdit({ clickable: value, file: image });
                    setClickable(value);
                  }}
                  size="small"
                >
                  {clickable ? <HighlightOffRounded /> : <AdsClickRounded />}
                </IconButton>
              </Tooltip>
              <IconButton
                style={{
                  position: 'absolute',
                  right: 4,
                  top: 4,
                  zIndex: 5,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
                size="small"
              >
                <DeleteOutlineRounded style={{ color: red[500] }} />
              </IconButton>
              <Grid
                container
                alignItems="flex-start"
                style={{
                  height: '100%',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                }}
                wrap="nowrap"
              >
                <Grid
                  container
                  component={Paper}
                  variant="outlined"
                  margin="auto"
                  sx={{
                    border: `2px solid ${grey[300]}`,
                    borderRadius: 1.5,
                    height: 50,
                    width: 50,
                  }}
                >
                  <input
                    accept="image/*"
                    name="img"
                    id={id}
                    type="file"
                    style={{ display: 'none' }}
                    onChange={uploadFile}
                  />
                  <CardActionArea style={{ borderRadius: 12, height: '100%', cursor: 'pointer' }}>
                    <label htmlFor={id}>
                      <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
                        {uploadingImage ? (
                          <CircularProgress size={30} />
                        ) : (
                          <CloudUploadOutlined sx={{ color: grey[300] }} fontSize="large" />
                        )}
                      </Grid>
                    </label>
                  </CardActionArea>
                </Grid>
              </Grid>
            </>
          ) : (
            !initial?.file && (
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                style={{
                  height: '100%',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  background: 'transparent',
                }}
                wrap="nowrap"
              >
                <ImageRounded fontSize="large" style={{ color: grey[500] }} />
              </Grid>
            )
          )}
        </Grid>
      </Grid>

      {!editable && initial?.clickable !== false && initial?.file && (
        <ImageDialog open={dialog} onClose={() => setDialog(false)} src={initial?.file?.location} />
      )}
    </Grid>
  );
}
